import { getEnvVar } from './utils/getEnvVar';

export const oktaAuthConfig = {
  issuer: getEnvVar('VITE_OKTA_ISSUER'),
  redirectUri: window.location.origin + '/implicit/callback',
  clientId: getEnvVar('VITE_OKTA_CLIENTID'),
  pkce: true,
  scopes: getEnvVar('VITE_OKTA_SCOPES')
    .split(/[\s,]+/)
    .filter(Boolean),
  services: {
    autoRenew: true
  },
  tokenManager: {
    expireEarlySeconds: 60
  }
};
